import { Image } from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import type { CSSProperties, ReactNode } from "react";

interface ISSHeaderCardProps {
  backgroundUrl: string;
  alt: string;
  children: ReactNode;
  mainColor?: string;
  variant: "ranked" | "skinLink" | "product";
  isOutOfStock?: boolean;
}

const SSHeaderCard: React.FC<ISSHeaderCardProps> = ({
  variant,
  isOutOfStock = false,
  backgroundUrl,
  alt,
  children,
  mainColor = "#000000",
}) => {
  const bgImageVar: { [key: string]: CSSProperties } = {
    ranked: {
      "--image-url": `radial-gradient(circle at 0px 0, ${mainColor} 0%, rgba(255,255,255,0) 70%), url(${backgroundUrl})`,
    } as CSSProperties,
    skinLink: {
      "--image-url": `url(${backgroundUrl})`,
    } as CSSProperties,
    product: {
      "--image-url": `url(${backgroundUrl})`,
    } as CSSProperties,
  };
  const cssClasses = {
    header: {
      base: `absolute top-0 left-0 w-full ${isOutOfStock ? "opacity-50" : ""}`,
      ranked:
        "h-[280px] background-image-[var(--image-url)] opacity-15 bg-center",
      skinLink:
        "h-[400px] bg-no-repeat bg-[50%_-6rem] short-light-gradient-image-[var(--image-url)]",
      product:
        "h-[400px] bg-no-repeat bg-cover short-light-gradient-image-[var(--image-url)]",
    },
    container: {
      ranked: "",
      skinLink: "relative pt-[170px]",
      product: "relative pt-[170px]",
    },
  };

  return (
    <>
      <div
        className={`${cssClasses.header.base} ${cssClasses.header[variant]}`}
        style={bgImageVar[variant]}
      />
      <AppSkeleton>
        <div className={cssClasses.container[variant]}>
          {variant === "ranked" && (
            <Image alt={alt} fit="contain" h={170} src={backgroundUrl} />
          )}
          {children}
        </div>
      </AppSkeleton>
    </>
  );
};

export default SSHeaderCard;
